import { Stack, styled, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ListTitle, ToggleListContainer } from './styles';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import {
  VisitStatusEnum,
  useBookmarkSelector,
} from 'pages/exhibitor/exhibitorBookmarks';
import { ExhibitorCard } from '../common';

const ScrollContainer = styled('div')({
  width: '102%',
  '& > div::-webkit-scrollbar': {
    width: 6,
  },
  '& > div::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '& > div::-webkit-scrollbar-thumb': {
    background: 'rgba(149, 152, 154, 0.43)',
    borderRadius: 5,
  },
  '& > div::-webkit-scrollbar-thumb:hover': {
    background: 'rgba(149, 152, 154, 1)',
  },
});

const ScrollabelContent = styled(Stack)({});

const PersonalExhibitorsList = ({ locale, loggedUser }) => {
  //hooks
  const intl = useIntl();
  const i18n = translations.ExhibitorsV2(intl);
  const history = useHistory();
  const theme = useTheme();
  const {
    exhibitorsManage,
    folders: storeFolders,
    currentFolderOnView,
  } = useBookmarkSelector();

  const exhibitorsWithoutFolder = exhibitorsManage.filter(
    (ex) => !storeFolders.find((f) => f.exhibitors.includes(ex.salesforceId))
  );

  const exhibitorsInFolder = currentFolderOnView?.folderId
    ? currentFolderOnView?.exhibitors.map((exId) =>
        exhibitorsManage.find((ex) => ex.salesforceId === exId)
      )
    : [];

  const totExhibitorsToVisit =
    exhibitorsWithoutFolder.filter(
      (ex) => ex?.status === VisitStatusEnum.TO_VISIT
    )?.length || 0;

  const totExhibitorsVisited =
    exhibitorsWithoutFolder.filter(
      (ex) => ex?.status === VisitStatusEnum.VISITED
    )?.length || 0;

  const totExhibitorsCurrentFolderToVisit =
    exhibitorsInFolder.filter((ex) => ex?.status === VisitStatusEnum.TO_VISIT)
      ?.length || 0;
  const totExhibitorsCurrentFolderVisited =
    exhibitorsInFolder.filter((ex) => ex?.status === VisitStatusEnum.VISITED)
      ?.length || 0;

  //states
  const [toVisit, setToVisit] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const myListParam = params.get('my_list');
    if (myListParam === '0' || myListParam === '1') {
      setToVisit(myListParam === '0');
    }
  }, []);

  const navigateExhibitorDetail = (exhibitor) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    const historyState = history.location.state;
    const state = {
      ...historyState,
      exhibitor: {
        ...exhibitor,
      },
    };
    history.push('/detail', state);
  };

  return (
    <Stack gap={'25px'} width={'100%'}>
      <ToggleListContainer>
        <ListTitle
          onClick={() => setToVisit(true)}
          variant="m"
          sx={{ cursor: 'pointer' }}
          borderBottom={
            toVisit
              ? `2px solid ${theme.palette.primary.main}`
              : `2px solid ${theme.palette.grey[200]}`
          }
        >
          {i18n.Common.toVisit}
          <span
            style={{
              marginLeft: '10px',
              fontSize: '14px',
              color: toVisit ? '#E2001A' : 'black',
              // color: toVisit ? '#EC0E00' : 'black',
            }}
          >
            {`(${
              currentFolderOnView?.folderId
                ? totExhibitorsCurrentFolderToVisit
                : totExhibitorsToVisit
            })`}{' '}
          </span>
        </ListTitle>
        <ListTitle
          onClick={() => setToVisit(false)}
          variant="m"
          sx={{ cursor: 'pointer' }}
          borderBottom={
            !toVisit
              ? `2px solid ${theme.palette.primary.main}`
              : `2px solid ${theme.palette.grey[200]}`
          }
        >
          {i18n.Common.visited}
          <span
            style={{
              marginLeft: '10px',
              fontSize: '14px',
              color: !toVisit ? '#E2001A' : 'black',
              // color: !toVisit ? '#EC0E00' : 'black',
            }}
          >
            {`(${
              currentFolderOnView?.folderId
                ? totExhibitorsCurrentFolderVisited
                : totExhibitorsVisited
            })`}{' '}
          </span>
        </ListTitle>
      </ToggleListContainer>
      <ScrollContainer>
        <ScrollabelContent
          gap={'25px'}
          width={'100%'}
          style={{
            maxHeight: '665px',
            overflowY: 'auto',
          }}
        >
          {currentFolderOnView?.folderId ? (
            exhibitorsInFolder
              .filter((ex) => {
                if (toVisit) return ex?.status === VisitStatusEnum.TO_VISIT;
                else return ex?.status === VisitStatusEnum.VISITED;
              })
              .map((ex, idx) => (
                <ExhibitorCard
                  key={idx}
                  exhibitor={ex}
                  isOnPersonalPage={true}
                  isVisited={!toVisit}
                  locale={locale}
                  loggedUser={loggedUser}
                  navigateExhibitorDetail={navigateExhibitorDetail}
                />
              ))
          ) : (
            <>
              {exhibitorsWithoutFolder
                .filter((ex) => {
                  if (toVisit) return ex?.status === VisitStatusEnum.TO_VISIT;
                  else return ex?.status === VisitStatusEnum.VISITED;
                })
                .map((ex, idx) => (
                  <ExhibitorCard
                    key={idx}
                    exhibitor={ex}
                    isOnPersonalPage={true}
                    isVisited={!toVisit}
                    locale={locale}
                    loggedUser={loggedUser}
                    navigateExhibitorDetail={navigateExhibitorDetail}
                  />
                ))}
            </>
          )}
        </ScrollabelContent>
      </ScrollContainer>
    </Stack>
  );
};
export default PersonalExhibitorsList;
